import { axiosInstance } from 'hb-react/shared/utils/axios';

const request = ({ url, text, lang, type, attribute }) => {
  const method = text?.length > 2000 ? 'post' : 'get';
  const envelope = method === 'post' ? 'data' : 'params';

  return axiosInstance({
    url,
    method,
    [envelope]: {
      text,
      lang,
      type,
      attribute,
    },
  }).then((response) => response.data);
};

export const translationRequest = ({ id, text, lang, type, attribute }) =>
  request({ url: Routes.translation_path(id), text, lang, type, attribute });

export const detectLanguageRequest = ({ id, text, lang, type, attribute }) =>
  request({
    url: Routes.detect_translation_path(id),
    text,
    lang,
    type,
    attribute,
  });
